import * as se from './ServerErrors';
export var inSufficientFundsErrorCodes = ['pmt1001', 'pmt1002', 'pmt1003'];
export var multiMonthBillingPeriod = ['P6M', 'P12M'];
export var ServerErrorsDataMap = new Map([['CART-VAL-0101', se.unrecoverableCart], ['CARTITEM-VAL-0201', se.cartWithNoItems], ['CB-0801', se.circuitBreaker], ['CB-BFF-001', se.circuitBreaker], ['CSDK-003', se.inccorectPostalCode], ['MOP-VAL-0301', se.noPaymentMethods], ['ORD-602', se.itemOnAnotherOrder], ['ORD-607', se.mopGeneric],
// User not eligible (cart/checkout service)
['ORD-608', se.mopGeneric],
// Invalid catalog or price id (cart/checkout service)
['ORD-9', se.noCarts], ['placeOrder.generic', se.placeorderGeneric], ['PM-003', se.inlineFormError], ['PM-03', se.inlineFormError], ['pmt28', se.mopGeneric],
// Backend timeout
['pmt1000', se.declinedInvalidPaymentInfoDoNotHonor],
// Do not honor
['pmt1001', se.insufficientFundsLimitExceeded], ['pmt1002', se.insufficientFundsLimitExceeded], ['pmt1003', se.insufficientFundsActivityLimitExceeded], ['pmt1001-MM', se.insufficientFundsLimitExceededMultiMonth], ['pmt1002-MM', se.insufficientFundsLimitExceededMultiMonth], ['pmt1003-MM', se.insufficientFundsActivityLimitExceededMultiMonth], ['pmt1004', se.paymentProcessingIssueDuplicateTransaction],
// Duplicate Transaction
['pmt1005', se.unsupported], ['pmt1006', se.mopGeneric],
// Set Up Error - Merchant
['pmt1007', se.paymentProcessingIssueInvalidMerchantId],
// Invalid Merchant ID
['pmt1008', se.mopGeneric],
// Set Up Error - Amount
['pmt1009', se.mopGeneric],
// Set Up Error - Hierarchy
['pmt1010', se.mopGeneric],
// Set Up Error - Card
['pmt1011', se.mopGeneric],
// Set Up Error - Terminal
['pmt1012', se.mopGeneric],
// Partial Approval For Amount In Group III Version
['pmt1013', se.declinedInvalidPaymentInfoProcessDeclined],
// Processor Declined
['pmt1014', se.mopGeneric],
// Invalid Store
['pmt1015', se.paymentProcessingIssueInvalidMerchantId],
// Invalid Client ID
['pmt1016', se.paymentProcessingIssueInvalidMerchantId],
// Invalid Merchant Number
['pmt1017', se.paymentProcessingIssueDeclined],
// Declined
['pmt1018', se.mopGeneric],
// Invalid Amount
['pmt1019', se.mopGeneric],
// Invalid Transaction Division Number
['pmt1020', se.mopGeneric],
// Transaction amount exceeds the transaction division limit
['pmt1021', se.restrictionOnCard], ['pmt1022', se.mopGeneric],
// Invalid Secure Payment Data
['pmt1023', se.paymentProcessingIssueProcessorNetworkUnavailable],
// Processor Network Unavailable - Try Again
['pmt2000', se.invalidPaymentInfo],
// do not honor
['pmt20001', se.mopGeneric],
// Amount cannot be negative
['pmt20002', se.mopGeneric],
// Amount is required
['pmt20003', se.mopGeneric],
// Amount is an invalid format
['pmt20004', se.mopGeneric],
// Amount is too large
['pmt20005', se.unsupported], ['pmt20006', se.mopGeneric],
// Custom field is too long
['pmt20007', se.mopGeneric],
// Order ID is too long
['pmt20008', se.mopGeneric],
// Cannot provide a billing address unless also providing a credit card
['pmt20009', se.mopGeneric],
// Transaction can only be voided if status is authorized or submitted_for_settlement
['pmt2001', se.expired], ['pmt20010', se.mopGeneric],
// Cannot refund credit
['pmt20011', se.mopGeneric],
// Cannot refund a transaction unless it is settled
['pmt20012', se.mopGeneric],
// Cannot submit for settlement unless status is authorized
['pmt20013', se.mopGeneric],
// Cannot determine payment method
['pmt20014', se.mopGeneric],
// Custom field is invalid
['pmt20015', se.mopGeneric],
// Customer ID is invalid
['pmt20016', se.mopGeneric],
// Customer does not have any credit cards
['pmt20017', se.mopGeneric],
// Transaction has already been refunded
['pmt20018', se.paymentProcessingIssueInvalidMerchantId],
// Merchant account ID is invalid
['pmt20019', se.mopGeneric],
// Merchant account is suspended
['pmt2002', se.invalidNumber], ['pmt20020', se.mopGeneric],
// Cannot provide both payment_method_token and credit_card attributes
['pmt20021', se.mopGeneric],
// Cannot provide both payment_method_token and customer_id unless the payment_method belongs to the customer
['pmt20022', se.mopGeneric],
// Cannot provide both payment_method_token and subscription_id unless the payment method belongs to the subscription
['pmt20023', se.unsupported], ['pmt20024', se.paymentProcessingIssueTokenInvalid],
// Payment method token is invalid
['pmt20025', se.mopGeneric],
// Processor authorization code cannot be set unless for a voice authorization
['pmt20026', se.mopGeneric],
// Refund amount cannot be more than the authorized amount
['pmt20027', se.mopGeneric],
// Cannot refund transaction with suspended merchant account
['pmt20028', se.mopGeneric],
// Settlement amount cannot be more than the authorized amount
['pmt20029', se.mopGeneric],
// Cannot provide both subscription_id and customer_id unless the subscription belongs to the customer
['pmt2003', se.invalidExpDate], ['pmt20030', se.mopGeneric],
// Subscription ID is invalid
['pmt20031', se.mopGeneric],
// Transaction type is invalid
['pmt20032', se.mopGeneric],
// Transaction type is required
['pmt20033', se.mopGeneric],
// Vault is disabled
['pmt20034', se.mopGeneric],
// Subscription status must be past due
['pmt20035', se.mopGeneric],
// Merchant account does not support refunds
['pmt20036', se.mopGeneric],
// Amount must be greater than zero
['pmt20037', se.mopGeneric],
// Tax amount cannot be negative
['pmt20038', se.mopGeneric],
// Tax amount is an invalid format
['pmt20039', se.mopGeneric],
// Tax amount is too large
['pmt2004', se.paymentProcessingIssueNoAccount],
// No Account
['pmt20040', se.mopGeneric],
// Purchase order number is too long
['pmt20041', se.mopGeneric],
// Voice Authorization is not allowed for this card type
['pmt20042', se.mopGeneric],
// Transaction cannot be cloned if payment method is stored in Vault
['pmt20043', se.mopGeneric],
// Cannot clone voice authorization transactions
['pmt20044', se.mopGeneric],
// Unsuccessful transaction cannot be cloned
['pmt20045', se.mopGeneric],
// Credits cannot be cloned
['pmt20046', se.mopGeneric],
// Cannot clone transaction without submit_for_settlement flag
['pmt20047', se.mopGeneric],
// Voice Authorizations are not supported for this processor
['pmt20048', se.mopGeneric],
// Credits are not supported by this processor
['pmt20049', se.mopGeneric],
// Purchase order number is invalid
['pmt2005', se.mopGeneric],
// Card Account Length Error
['pmt20050', se.mopGeneric],
// Processor authorization code is invalid
['pmt20051', se.mopGeneric],
// Payment method conflict with venmo sdk
['pmt20052', se.mopGeneric],
// Channel is too long
['pmt20053', se.mopGeneric],
// Settlement amount is less than service fee amount
['pmt20054', se.mopGeneric],
// Service fee is not allowed on credits
['pmt20055', se.mopGeneric],
// Sub merchant account requires service fee amount
['pmt20056', se.mopGeneric],
// Service fee amount cannot be negative
['pmt20057', se.mopGeneric],
// Service fee amount format is invalid
['pmt20058', se.mopGeneric],
// Service fee amount is too large
['pmt20059', se.mopGeneric],
// Service fee amount not allowed on master merchant account
['pmt2006', se.mopGeneric],
// No Such Issuer
['pmt20060', se.mopGeneric],
// Merchant account does not support MOTO
['pmt20061', se.mopGeneric],
// Cannot refund with pending merchant account
['pmt20062', se.mopGeneric],
// Cannot hold in escrow
['pmt20063', se.mopGeneric],
// Cannot release from escrow
['pmt20064', se.mopGeneric],
// Cannot cancel release
['pmt20065', se.mopGeneric],
// Cannot partially refund escrowed transaction
['pmt20066', se.mopGeneric],
// Payment method nonce unknown
['pmt20067', se.mopGeneric],
// PayPal not enabled
['pmt20068', se.mopGeneric], ['pmt20069', se.mopGeneric],
// Company name/DBA section is invalid
['pmt2007', se.incorrectCVV], ['pmt20071', se.mopGeneric],
// Dynamic descriptors not enabled
['pmt20072', se.mopGeneric],
// Descriptor name is invalid
['pmt20073', se.mopGeneric],
// International phone number is invalid
['pmt20074', se.mopGeneric],
// URL must be 13 characters or shorter
['pmt20075', se.paymentProcessingIssueCanNotUsePaymentMoreThanOnce],
// Payment processing issue / cannot use payment more than once
['pmt2008', se.byInstitution], ['pmt2009', se.declinedInvalidPaymentInfoProcessDeclined], ['pmt2010', se.invalidPaymentInfo], ['pmt2011', se.declinedInvalidPaymentInfoProcessDeclined],
// processor declined
['pmt2012', se.paymentProcessingIssueTransactionNotAllowed],
// Transaction Not Allowed
['pmt2013', se.byInstitution], ['pmt2014', se.byInstitution], ['pmt2015', se.paymentProcessingIssueInvalidTransaction],
// Invalid Transaction
['pmt2016', se.paymentProcessingIssueViolation],
// Violation
['pmt2017', se.paymentProcessingIssueSecurityViolation],
// Security Violation
['pmt2018', se.mopGeneric],
// Declined - Updated Cardholder Available
['pmt2019', se.mopGeneric],
// Processor Does Not Support This Feature
['pmt2020', se.mopGeneric],
// Encryption Error
['pmt2021', se.mopGeneric],
// Surcharge Not Permitted
['pmt2022', se.mopGeneric],
// Inconsistent Data
['pmt2023', se.mopGeneric],
// No Action Taken
['pmt2024', se.mopGeneric],
// Authorization could not be found to reverse
['pmt2025', se.mopGeneric],
// Already Reversed
['pmt2026', se.mopGeneric],
// Invalid Authorization Code
['pmt2027', se.byInstitution], ['pmt2028', se.invalidPaymentInfo], ['pmt2029', se.byInstitution], ['pmt2030', se.paymentProcessingIssueCallIssuerPickUpCard],
// Call Issuer. Pick Up Card
['pmt2031', se.mopGeneric],
// Invalid SKU Number
['pmt2032', se.mopGeneric],
// Invalid Credit Plan
['pmt2033', se.invalidNumber], ['pmt2034', se.mopGeneric],
// Invalid Level III Purchase
['pmt2035', se.invalidPaymentInfo], ['pmt2036', se.mopGeneric],
// Reversal amount does not match authorization amount
['pmt2037', se.mopGeneric],
// Merchant not MasterCard SecureCode enabled
['pmt2038', se.invalidBillingAddress], ['pmt2039', se.invalidGeneric], ['pmt2040', se.mopGeneric],
// Invalid Transaction Data
['pmt2041', se.mopGeneric],
// Invalid Tax Amount
['pmt2042', se.paypalError], ['pmt2043', se.mopGeneric],
// Invalid Currency Code
['pmt2044', se.mopGeneric],
// Refund Time Limit Exceeded
['pmt2045', se.paypalError], ['pmt2046', se.mopGeneric],
// Authorization Expired
['pmt2047', se.paypalError], ['pmt2048', se.paypalError], ['pmt2049', se.paypalError], ['pmt2050', se.paypalError], ['pmt2051', se.mopGeneric],
// PayPal Payee Email Incorrectly Formatted
['pmt2052', se.paypalError], ['pmt2053', se.paypalError], ['pmt2054', se.paypalError], ['pmt2055', se.paypalError], ['pmt2056', se.paypalError], ['pmt2057', se.mopGeneric],
// PayPal Merchant Account Configuration Error
['pmt2060', se.mopGeneric],
// Postal code can only contain letters, numbers, spaces, and hyphens
['pmt2061', se.paymentProcessingIssueCustomerIdAlreadyTaken],
// Customer ID has already been taken.
['pmt20075', se.mopGeneric],
// Cannot use a payment_method_nonce more than once
['pmt20076', se.mopGeneric],
// Unknown payment_method_nonce
['pmt2085', se.mopGeneric],
// Invalid email
['pmt30002', se.mopGeneric],
// Payment method nonce consumed
['pmt30026', se.unsupported], ['pmt30027', se.cardNumberLength12], ['pmt30029', se.cvvLength], ['pmt30031', se.invalidExpDate],
// Expiration date is invalid
['pmt30034', se.mopGeneric],
// Expiration year is invalid
['pmt30035', se.cardNumberRequired], ['pmt30038', se.mopGeneric],
// Credit card number is not an accepted test number
['pmt30039', se.paymentProcessingIssueTokenInvalid],
// Update Existing Token is invalid
['pmt30040', se.duplicateCard],
// this payment method has been already added.
['pmt30049', se.unsupported], ['pmt30053', se.inccorectPostalCode], ['pmt30064', se.cardNumberRequired], ['pmt30072', se.cardOnMultipleAccounts],
// message updated -- #2
['pmt30100', se.billingAddressFailed], ['pmt30201', se.noCheggCredit], ['pmt30210', se.cardNumberRequired], ['pmt30211', se.cardNumberLength18], ['pmt30213', se.unsupported],
// invalid cart type
['pmt30221', se.expired], ['pmt30230', se.nameOnCardRequired], ['pmt30240', se.secCodeRequired], ['pmt30241', se.secCodeLength4], ['pmt30242', se.secCodeLength3], ['pmt30260', se.noPaypalAccount], ['pmt30280', se.invalidYifteeCode], ['pmt30281', se.yifteeFailed], ['pmt30282', se.yifteeExpired], ['pmt30300', se.systemGeneric], ['pmt30301', se.invalidPaymentInfo], ['pmt30312', se.cardNumberLength14], ['pmt31001', se.DoNotHonorFraud],
// BRAINTREE Gateway Rejected: fraud
['pmt31002', se.mopGeneric],
// BRAINTREE Gateway Rejected: application_incomplete
['pmt31003', se.incorrectCVV],
// BRAINTREE Gateway Rejected: cvv
['pmt31004', se.cardOnMultipleAccounts],
// BRAINTREE Gateway Rejected: duplicate
['pmt31005', se.DoNotHonorFraud],
// BRAINTREE Gateway Rejected: risk_threshold
['pmt31006', se.paymentProcessingIssueTokenInvalid],
// BRAINTREE Gateway Rejected: token_issuance
['pmt31007', se.invalidGeneric],
// BRAINTREE 81750 Credit card number prohibited
['pmt31008', se.paymentProcessingIssueTokenInvalid],
// BRAINTREE Payment method token is invalid.
['pmt32035', se.mopGeneric],
// TRY AGAIN
['pmt500', se.invalidPaymentInfo], ['pmt5000', se.mopGeneric], ['PROMO-VAL-0601', se.unrecognizedCoupon], ['PROMO-VAL-0602', se.expiredCoupon], ['RCLY-31005', se.fraudRiskCheck] // Recurly - VPN detected
]);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/commerce-utils/dist/esm/constants/ServerErrorsDataMap.js
// module id = 1380
// module chunks = 11